import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {NzModalModule, NzModalService} from "ng-zorro-antd/modal";
import {NonNullableFormBuilder, ReactiveFormsModule} from "@angular/forms";
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzFormDirective} from 'ng-zorro-antd/form';
import {NgForOf} from '@angular/common';
import {ShopInfoBean} from '../../bean/shop.info.bean';
import {EchUtils} from '../../ech-utils/ech-utils';
import {debounceTime, distinctUntilChanged, shareReplay} from 'rxjs';
import {ShopService} from "./shop.service";
import {NzIconDirective} from "ng-zorro-antd/icon";

@Component({
  selector: 'shop-system-info',
  templateUrl: './shop.info.component.html',
  styleUrl: './shop.info.component.less',
  imports: [
    NzModalModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzFormDirective,
    NgForOf,
    NzIconDirective,
  ],
  standalone: true
})
export class ShopInfoComponent  implements OnInit {
  isVisible: boolean = false;
  isDropdownOpen: boolean = false;
  shopStoreList: ShopInfoBean[] = [];


  constructor(private echUtils: EchUtils,
              private router: Router,
              private nzModalService: NzModalService,
              private fb: NonNullableFormBuilder,
              public shopService: ShopService) {
    this.shopService.shopInfoListObservable.subscribe((response: any) => {
      this.shopStoreList = response;
      this.shopService.validateForm.controls.shopInfo.setValue(response[0],{
        emitEvent:false
      });
      this.shopService.shopInfoSubject.next(response[0]);
      this.shopService.validateForm.controls.shopInfo.valueChanges.pipe(
        debounceTime(800), // Wait 800ms after the last event before emitting
        distinctUntilChanged() // Only emit if the value changed
      ).subscribe((value: any) => {
        this.shopService.shopInfoListObservable = this.echUtils.postObservable("/api/manageShopSaleShop/userShop/setCookie4ShopId/".concat(value.id))
          .pipe(shareReplay(1));
        this.shopService.shopInfoListObservable.subscribe((response:any)=> {
          this.isDropdownOpen=false;
        });
      });
    });
  }

  handleCancel() {
    this.isVisible = false;
    this.router.navigate(['/login']);
  }

  handleOk() {
    this.shopService.shopInfoListObservable = this.echUtils.postObservable("/api/manageShopSaleShop/userShop/setCookie4ShopId"
      .concat(this.shopService.validateForm.controls.shopInfo.value.id)).pipe(shareReplay(1));
    this.shopService.shopInfoListObservable.subscribe((shopInfoList:any) => {
      this.isVisible = false;
      this.shopService.validateForm.controls.shopInfo.setValue(shopInfoList[0],{
        emitEvent:false
      });
      this.shopService.shopInfoSubject.next(shopInfoList[0]);
    });
  }

  ngOnInit(): void {
  }

  openDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
